export const paths = ['/contacts'];
